module.exports = {
  feedbackCardTitle: { default: '32px', medium: '30px', small: '28px' },
  title: { default: '18px', medium: '16px', small: '14px' },
  bodyText: { default: '16px', medium: '14px', small: '12px' },
  smallBodyText: { default: '14px', medium: '12px', small: '10px' },
  quickReplies: { default: '16px', medium: '14px', small: '12px' },
  pills: { default: '14px', medium: '12px', small: '10px' },
  hoverText: { default: '12px', medium: '10px', small: '10px' },
  headerTitleFull: { default: '24px', medium: '22px', small: '18px' },
  supportText: { default: '20px', medium: '18px', small: '16px' }
}
